import { Trans, useLingui } from '@lingui/react'
import { bool } from 'prop-types'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { PHONE_NUMBER_MODAL } from 'shared/consts/checkout'
import { setPhoneNumberAction } from 'shared/store-checkout/duck/orderDraft'
import Button from 'views/components/atoms/Button'
import Form from 'views/components/atoms/Form'
import InputTextWithWithFloatingLabel from 'views/components/molecules/InputTextWithFloatingLabel'
import Modal from 'views/components/molecules/Modal'
import useMountPoints from 'views/enhancers/useMountPoints'
import { i18nType } from 'views/utils/propTypes'

const PhoneNumberModal = ({ open }) => {
  const { i18n } = useLingui()
  const PHONE_INPUT_ID = 'phonenumber-modal-phone'
  const dispatch = useDispatch()

  const mountPoints = useMountPoints()
  const history = useHistory()

  const submitPhoneNumber = e => {
    e.preventDefault()
    const phoneNumber = document.getElementById(PHONE_INPUT_ID).value
    dispatch(setPhoneNumberAction({ phoneNumber, history, mountPoints }))
  }

  return (
    <Modal
      size="medium"
      id={PHONE_NUMBER_MODAL}
      title={i18n._('checkout.phonenumberModal.title')}
      isClientSideControlled
      open={open}
    >
      <p className="u-padding-small--bottom">
        <Trans id="addressForm.tooltip.phone" />
      </p>

      <Form name="phonenumber-modal-form" onSubmit={e => submitPhoneNumber(e)}>
        <div className="l-flex l-flex--vertical-stretch l-flex__row@medium">
          <div className="l-flex__fill-gap u-margin--right@medium u-margin-large--bottom u-no-margin--bottom@medium">
            <InputTextWithWithFloatingLabel
              name="phone"
              id={PHONE_INPUT_ID}
              inputType="tel"
              required
            >
              <Trans id="general.label.tel" />
            </InputTextWithWithFloatingLabel>
          </div>
          <div className="l-flex__fill-gap">
            <Button name="phonenumber-modal-button" type="submit">
              <Trans id="general.form.label.phone.confirm" />
            </Button>
          </div>
        </div>
      </Form>
    </Modal>
  )
}

PhoneNumberModal.propTypes = {
  open: bool,
  i18n: i18nType.isRequired,
}

PhoneNumberModal.defaultProps = { open: false }

export default PhoneNumberModal
